import { cn } from "@/lib/utils";

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn("animate-pulse bg-gray-100 rounded-[var(--sf-radius)]", className)} />;
}

export function ProductCardSkeleton() {
  return (
    <div className="ecommerce-card overflow-hidden">
      <Skeleton className="aspect-[4/5]" />
      <div className="p-4 space-y-2.5">
        <Skeleton className="h-3.5 w-2/3 mx-auto" />
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-4 w-1/3 mx-auto" />
      </div>
    </div>
  );
}

export function ProductGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <ProductCardSkeleton key={i} />
      ))}
    </div>
  );
}
